module.exports = __webpack_public_path__ + "static/media/logo.2c035b2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 1907
// module chunks = 0